<template>
    <div>
        <img src="img/banner-5.jpg" class="nark img-banner">
         <div class="Servic ">
            <p>联系我们</p>
            <span>—— 吉林医药设计院有限公司 —— </span>
        </div>
        <div class="lisd">
            <ul class="servicen-emr nrk">
                <li>
                    <h2>业务院长</h2>
                    <div>
                        <span>电话: 0086-431-85640664</span>
                        <span>手机: 13944948981</span>
                    </div>
                </li>
                <li>
                    <h2>院工艺处</h2>
                    <div>
                        <span>电话: 0086-431-85676273</span>
                        <span>手机: 13500802935</span>
                    </div>
                </li>
                <li>
                    <h2>经营计划处</h2>
                    <div>
                        <span>电话: 0086-431-85679593</span>
                    </div>
                </li>
                <li>
                    <h2>设计管理处</h2>
                    <div>
                        <span>电话: 0086-431-85640672</span>
                        <span>手机: 18943683768</span>
                    </div>
                </li>
                <li>
                    <h2>洁净检测</h2>
                    <div>
                        <span>手机: 18686618169</span>
                        <span>13069110608</span>
                    </div>
                </li>
            </ul>
            <div class="nrk">
                <Baidu-Map/>
            </div>
        </div>
    </div>
</template>

<script>
import {mapState} from 'vuex'
import SubNavigation from '@/components/pc/SubNavigation'
import BaiduMap from '@/components/BaiduMap'
export default {
    components:{
      SubNavigation,
      BaiduMap
    } ,
     mounted() {
        this.$store.dispatch('PostMain');
    },
    computed:{
        ...mapState({
            MAIN:state=>state.share.MAIN
        })
    },
}
</script>

<style scoped>
    
.employ {
    width: 90%;
    margin: 12px auto;
}

.employ h1 {
    text-align: center;
    color: #333333;
    font-size: 40px;
    padding: 60px 0 60px 0;
    font-weight: bold;
    overflow: hidden;
}

.employ p {
    text-align: justify;
    width: 100%;
    margin-bottom: 28px;
    font-size: 13px;
    color: #666666;
}
.lisd{
    width: 100%;
    overflow: hidden;
    background-color: #f7f7f7;
    padding: 20px 0;
}
.servicen-emr {
    margin: 0 auto;
    overflow: hidden;
    margin-bottom: 30px;
}

.servicen-emr li {
    float: left;
    width: 16%;
    padding: 26px 1.5%;
    background-color: #fff;
    overflow: hidden;
    margin-left: 1%;
    border: 1px #fff solid;
    height: 80px;
    border-radius: 10px;
}
.servicen-emr li h2{
    display: block;
    width: 100%;
}
.servicen-emr li>div>span{
    color: #999;
    margin-top: 12px;
    display: block;
}
.servicen-emr li:nth-child(1){
    margin-left: 0;
}
    @media (max-width: 768px){
        .servicen-emr li{
            width: 40%;
            margin-bottom: 20px;
            border:none;
            padding: 26px 3%;
        }
        .servicen-emr li:nth-child(2n){
            margin-left: 4%;
        }
        .Servic{
            margin-top: 10px;
        }
        .Servic p{
            font-size: 22px;
        }
    }
</style>